import { Fill } from 'api';

const getFillStyle = (formatting?: Fill): React.CSSProperties => {
  if (!formatting || (!formatting.bg_color && !formatting.fg_color)) {
    return {};
  }
  const { bg_color: backgroundColor, fg_color: foregroundColor, pattern_type: patternType } = formatting;

  if (formatting && !backgroundColor && patternType === 'solid' && foregroundColor) {
    return {
      backgroundColor: foregroundColor,
    }
  }

  // If no pattern or solid pattern, just return background color
  if (!patternType || patternType === 'solid' || !foregroundColor && backgroundColor) {
    return {
      backgroundColor: backgroundColor as string,
    };
  }

  // Base style with background color
  const baseStyle: React.CSSProperties = {
    backgroundColor: backgroundColor as string,
  };

  // Add pattern-specific background images
  switch (patternType) {
    case 'lightHorizontal':
    case 'horizontal':
      return {
        ...baseStyle,
        backgroundImage: `repeating-linear-gradient(0deg, ${foregroundColor}, ${foregroundColor} 1px, transparent 1px, transparent 4px)`,
      };

    case 'lightVertical':
    case 'vertical':
      return {
        ...baseStyle,
        backgroundImage: `repeating-linear-gradient(90deg, ${foregroundColor}, ${foregroundColor} 1px, transparent 1px, transparent 4px)`,
      };

    case 'lightDown':
    case 'darkDown':
    case 'diagonal':
      return {
        ...baseStyle,
        backgroundImage: `repeating-linear-gradient(45deg, ${foregroundColor}, ${foregroundColor} 1px, transparent 1px, transparent 4px)`,
      };

    case 'lightUp':
    case 'darkUp':
      return {
        ...baseStyle,
        backgroundImage: `repeating-linear-gradient(-45deg, ${foregroundColor}, ${foregroundColor} 1px, transparent 1px, transparent 4px)`,
      };

    case 'lightGrid':
    case 'grid':
      return {
        ...baseStyle,
        backgroundImage: `
          repeating-linear-gradient(0deg, ${foregroundColor}, ${foregroundColor} 1px, transparent 1px, transparent 4px),
          repeating-linear-gradient(90deg, ${foregroundColor}, ${foregroundColor} 1px, transparent 1px, transparent 4px)
        `,
      };

    case 'dots':
    case 'lightDots':
      return {
        ...baseStyle,
        backgroundImage: `radial-gradient(circle at 50% 50%, ${foregroundColor} 1px, transparent 1px)`,
        backgroundSize: '4px 4px',
      };

    case 'gray125':
    case 'gray0625':
      return {
        ...baseStyle,
        backgroundImage: `radial-gradient(circle at 25% 25%, ${foregroundColor} 0.5px, transparent 0.5px)`,
        backgroundSize: '2px 2px',
      };

    default:
      return baseStyle;
  }
};

export default getFillStyle;
